import axios from '../utils/axios';

export interface ClientErrorReport {
  message: string;
  stack?: string;
  componentStack?: string;
  url: string;
  userAgent: string;
  occurredAt: string;
}

export async function reportClientError(report: ClientErrorReport): Promise<void> {
  try {
    await axios.post('/v1/uploads/client-error', report);
  } catch {
    // best-effort; never let the reporter throw
  }
}
